module.exports = __webpack_public_path__ + "static/media/cruznegra.69e3bcd2.svg";